import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { marketShareTerms } from '../../constants';
import { useCommonStore } from '../../../store/store';

export const CustomCheckbox = (props) => {

    const { context, data, node } = props;
    const { maxRows, setSelectedRowsIds, showToast } = context;

    const selectedRowsIds = useCommonStore(state => state.selectedRowsIds);

    const [isSelected, setSelected] = useState(data.isSelected);

    const currentRowId = data.officeId || data.brokerId || data.areaId || data.groupId;
    const rowIndex = node?.rowIndex;

    const handleSelection = async (e) => {
        e.stopPropagation();

        let filteredRows;

        if (!isSelected && (selectedRowsIds.length >= maxRows)) {
            showToast(marketShareTerms.MAX_ROWS_ARE_SELECTED);
            return;
        }

        filteredRows = !isSelected
            ? [...selectedRowsIds, currentRowId]
            : selectedRowsIds.filter(id => id !== currentRowId);

        setSelectedRowsIds(filteredRows);
    };

    return (
        <div id={`row-${node?.rowIndex}`} className='d-flex justify-content-center align-items-center'>
            <input
                id={rowIndex}
                type='checkbox'
                className='custom-checkbox'
                checked={isSelected}
                onChange={handleSelection}
            />
        </div>
    );
};

CustomCheckbox.proptypes = {
    api: PropTypes.object,
    context: PropTypes.object,
    data: PropTypes.object,
    node: PropTypes.object
};
